export interface FacetProps {
	id: string;
	label: string;
	terms: Array<object>;
	path: string;
}

export interface FacetOptions {
	id: string;
	label: string;
	value: string;
	active: boolean;
	count: number;
}

export interface FacetState {
	data: any;
}

export class Facet {
	private options: FacetOptions[] = [];

	constructor(public facets: FacetProps) {
		this.formatTerms();
	}

	get type(): string {
		return this.facets.id;
	}

	get values(): FacetOptions[] {
		return this.options;
	}

	formatTerms() {
		this.options = this.facets.terms.map((facet: any): FacetOptions => {
			return {
				id: this.facets.id,
				label: facet.values.label,
				value: facet.values.value,
				active: facet.values.active,
				count: facet.values.count,
			};
		});
	}
}
